(function () {
  console.log("✅ Order Deadline fix script loaded");

  document.addEventListener('variant:change', function (event) {
    const variant = event.detail && event.detail.variant;
    const orderDeadlineEl = document.querySelector('[data-order-deadline-app-unit]');

    if (!variant || !orderDeadlineEl) return;

    // Log for debugging
    console.log("🔁 Variant changed to ID:", variant.id);

    // Update the Order Deadline data-attribute
    orderDeadlineEl.setAttribute('data-variant-ids', variant.id);

    // Reinitialise Order Deadline
    if (typeof OrderDeadline !== 'undefined' && typeof OrderDeadline.init === 'function') {
      console.log("✅ Reinitialising Order Deadline");
      OrderDeadline.init();
    } else {
      // Fallback: force refresh of DOM block
      const clone = orderDeadlineEl.cloneNode(true);
      orderDeadlineEl.parentNode.replaceChild(clone, orderDeadlineEl);
      console.log("♻️ Fallback: Replaced Order Deadline block manually");
    }
  });
})();
